export enum StatusIndicator {
  None = 'none',
  Minor = 'minor',
  Major = 'major',
  Critical = 'critical'
}

export type Status = { description: string; indicator: StatusIndicator };
export type RawIncident = {
  id: string;
  components: { id: string; name: string }[];
  impact: 'minor' | 'major' | 'critical';
  name: string;
  shortlink: string;
  incident_updates: {
    id: string;
    body: string;
    created_at: string;
    display_at: string;
    status: string;
  }[];
  status:
    | 'operational'
    | 'degraded_performance'
    | 'partial_outage'
    | 'major_outage'
    | 'under_maintenance';
};
export type Incident = {
  id: string;
  type: 'incident' | 'maintenance';
  displayStatus: 'resolved' | 'minor' | 'major' | 'critical' | 'maintenance';
  status: RawIncident['status'];
  impact: RawIncident['impact'];
  name: string;
  shortlink: string;
  componentIds: string[];
  componentName: string;
  latestUpdate: RawIncident['incident_updates'][number];
  latestUpdateDisplayAt: string;
};
